/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["#video-cooperation[_ngcontent-%COMP%]{\r\n\t-webkit-transform-origin: top right;\r\n\t        transform-origin: top right;\r\n}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/case-practice-cooperation-video/case-practice-cooperation-video.component.css.shim.ngstyle.js.pre-build-optimizer.js